export default "/img/MQ.54b1d4791464fdcf2ba86f2c79eadf98.png";